// src/services/studentService.js
import axiosClient from "./axiosClient";

const route = "student";
const yearRoute = "studentYear";
const studentPaymentRoute = "studentPayment";
const studentEvaluationRoute = "studentEvaluation";

// Get all students with pagination and search
export const getAllStudents = async (page = 1, limit = 5, search = {}) => {
  try {
    const response = await axiosClient.get(`${route}/getAll`, {
      params: {
        page,
        limit,
        ...search,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Get all students without pagination (for select all functionality)
export const getAllStudentsWithoutPagination = async (
  totalRecords,
  search = ""
) => {
  try {
    const response = await axiosClient.get(`${route}/getAll`, {
      params: {
        page: 1,
        limit: totalRecords,
        search,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a new student
export const createStudent = async (studentData) => {
  try {
    const response = await axiosClient.post(`${route}`, studentData);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update an existing student
export const updateStudent = async (studentId, updateData) => {
  try {
    const response = await axiosClient.put(`${route}/${studentId}`, updateData);
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete a student
export const deleteStudent = async (studentId) => {
  try {
    const response = await axiosClient.delete(`${route}/${studentId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get a specific student by ID (if needed)
export const getStudentById = async (studentId) => {
  try {
    const response = await axiosClient.get(`${route}/${studentId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStudentByCode = async (code) => {
    const response = await axiosClient.get(`${route}/get-by-code/${code}`);
    return response
};

export const getStudentTransactions = async (studentId) => {
  try {
    const response = await axiosClient.get(`${route}/${studentId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const downloadStudentInfo = async (studentId) => {
  try {
    const response = await axiosClient.get(`${route}/download/${studentId}`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentPayment = async (
  studentId,
  studentYearId,
  filterParams
) => {
  try {
    const response = await axiosClient.get(
      `${studentPaymentRoute}/${studentId}`,
      {
        params: {
          studentYearId,
          ...filterParams,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStudentPayment = async (id, paymentData) => {
  try {
    const response = await axiosClient.put(
      `${studentPaymentRoute}/${id}`,
      paymentData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete a student payment
export const deleteStudentPayment = async (id) => {
  try {
    const response = await axiosClient.delete(`${studentPaymentRoute}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const changeStudentClass = async (studentId, classData) => {
  try {
    const response = await axiosClient.put(
      `${route}/levelingToNewGrade/${studentId}`,
      classData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/// YEAR ENDPOINTS
export const getStudentYears = async (studentId) => {
  try {
    const response = await axiosClient.get(`${yearRoute}`, {
      params: {
        studentId,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const addAcademicYear = async (academicYearData) => {
  try {
    const response = await axiosClient.post(`${yearRoute}`, academicYearData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const graduateStudent = async (studentId) => {
  try {
    const response = await axiosClient.put(`${route}/graduate/${studentId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// STUDENT EVALUATION

// Create Student Evaluation
export const createStudentEvaluation = async (evaluationData) => {
  try {
    const response = await axiosClient.post(
      `${studentEvaluationRoute}`,
      evaluationData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Get All Evaluations
export const getAllEvaluations = async () => {
  try {
    const response = await axiosClient.get(`${studentEvaluationRoute}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get Evaluation by Student ID
export const getEvaluationByStudentId = async (studentId) => {
  try {
    const response = await axiosClient.get(
      `${studentEvaluationRoute}/${studentId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Update Student Evaluation
export const updateStudentEvaluation = async (evaluationId, evaluationData) => {
  try {
    const response = await axiosClient.put(
      `${studentEvaluationRoute}/${evaluationId}`,
      evaluationData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete Student Evaluation
export const deleteStudentEvaluation = async (evaluationId) => {
  try {
    const response = await axiosClient.delete(
      `${studentEvaluationRoute}/${evaluationId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
